import axios from 'axios'

export const getRecruiterboxPositions = () => {
  return axios.get('https://jsapi.recruiterbox.com/v1/openings/?client_name=cheesecake')
}
